import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { getAggregatedJobDataForJobId } from '@collections/aggregations';
import { loadAvgResponseTime } from '@modules/reports/store/referral-reports.actions';
import { AvgResponseTimeObj } from '@modules/reports/store/referral-reports.selectors';
import { Store } from '@ngrx/store';
import { Job } from '@shared';
import { Pagination } from '@shared/pagination';

@Component({
  selector: 'mojo-dashboard-jobs-list',
  templateUrl: './dashboard-jobs-list.component.html',
})
export class DashboardJobsListComponent implements OnInit {
  @Input() allJobs: Pagination<Job>;
  @Output() reloadList = new EventEmitter();

  constructor(private store: Store<{}>) {}

  ngOnInit(): void {
    const ids = this.allJobs?.content.map((job) => job.id);
    this.store.dispatch(loadAvgResponseTime({ jobIds: ids }));
  }

  getAvgResponseTimes(jobId) {
    return this.store.select(AvgResponseTimeObj.getAvgResponseTimeForJobId(jobId));
  }

  pageChange(offset: number): void {
    this.reloadList.emit(offset);
  }

  getAggregatedJobData(jobId) {
    return this.store.select(getAggregatedJobDataForJobId, { jobId });
  }
}
